import React from 'react';
import { Fragment } from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Browse Button to go back or to Phenostore
const ExperimentInformationHeader = (props) => {
    return (
        <Fragment>
            <Grid item lg={12} align={"center"}>
                <Typography variant={"h6"}> Experiment ID </Typography>
                <Typography variant={"h5"}> {props.ExperimentID} </Typography>
            </Grid>
            <Grid item lg={12} align={"center"}>
                <Typography variant={"subtitle1"}> Owner: {props.Owner} </Typography>
            </Grid>
        </Fragment>
    );           
}

export default ExperimentInformationHeader;